import * as yup from 'yup';

export const EmailSchema = yup.string().email();
export const LoginFormSchema = yup.object().shape({
  email: yup.string().email(),
  password: yup.string()
});